import { createSlice } from "@reduxjs/toolkit";
import myLocalStorage from "../../utils/myLocalStorage";
import { validationValue } from "../../utils/validations";

const initialState = {
  employeeNumber: validationValue(myLocalStorage.get("employee_number"), null)
};

const trazabilitySlice = createSlice({
  name: "trazability",
  initialState,
  reducers: {
    changeEmployeeNumber: (state, action) => {
      const main = action.payload;
      myLocalStorage.set("employee_number", main);
      state.employeeNumber = main;
    },
    clearEmployeeNumber: (state, action) => {
      myLocalStorage.remove("employee_number");
      state.employeeNumber = null;
    }
  }
});

export const { changeEmployeeNumber, clearEmployeeNumber } =
  trazabilitySlice.actions;

export default trazabilitySlice.reducer;
